import React from 'react'
import PropTypes from 'prop-types'

import RadioButton from '../RadioButton/RadioButton'

import styles from './Filter.css'

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        caption: PropTypes.node.isRequired,
        isDisabled: PropTypes.bool,
        tooltipId: PropTypes.string,
    })).isRequired,
    checkedItem: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    onItemChange: PropTypes.func.isRequired,

    caption: PropTypes.node,
}

class Filter extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handleItemChange = this.handleItemChange.bind(this)
    }

    handleItemChange(checkedItem) {
        if (checkedItem !== this.props.checkedItem) {
            this.props.onItemChange(checkedItem)
        }
    }

    render() {
        const filterItems = this.props.items.map((item, index) => (
            <div
                key={`filterItem-${index}`}
                className={styles.item}
            >
                <RadioButton
                    name={item.name}
                    caption={item.caption}
                    isChecked={this.props.checkedItem === item.value}
                    isDisabled={item.isDisabled}
                    onChange={() => { this.handleItemChange(item.value) }}
                    tooltipId={item.tooltipId}
                />
            </div>
        ))

        const caption = this.props.caption ? (
            <span className={styles.caption}>{this.props.caption}</span>
        ) : null

        return (
            <div className={styles.base}>
                {caption}
                {filterItems}
            </div>
        )
    }
}

Filter.propTypes = propTypes

export default Filter



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/Filter/Filter.jsx